interface VerificationCapability {
  treeId: string;
  token: string;
}

let capturedCapability: VerificationCapability | null = null;

/**
 * Capture the URL-fragment capability before telemetry is initialized, then
 * immediately remove it from the browser URL. Fragment data is kept only in
 * module memory until the verification page consumes it.
 */
export function captureAccessNotificationVerificationCapability(): void {
  if (window.location.pathname !== '/verify-access-notification-email' || !window.location.hash) return;
  const params = new URLSearchParams(window.location.hash.slice(1));
  capturedCapability = {
    treeId: params.get('tree_id') ?? '',
    token: params.get('token') ?? '',
  };
  window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
}

export function getAccessNotificationVerificationCapability(): VerificationCapability | null {
  return capturedCapability;
}

export function clearAccessNotificationVerificationCapability(): void {
  capturedCapability = null;
}
